import { CommandButton, JournalTable, Modal, TableHeader } from "components";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import { convertNumber, useToggle } from "utils";
import { AdjustmentInventoryType, journalMap } from "../utils";
import moment from "moment";

export function JournalAdjusment(props: {
  type: "count" | "direct"
}) {
  const { isActive, toggle } = useToggle(false)
  const { watch } = useFormContext<AdjustmentInventoryType>()

  console.log(watch('adjusmentDetail'));
  

  const dataJournal = watch('adjusmentDetail').flatMap(i => {
    const amount = props.type === "count" ? (Number(i.different) * Number(i.avg_price_use)) : i.amount_adjustment;
    
    const inventoryAccount = `${i.coa_inventory_code} ${i.coa_inventory_name}`;
    const coexAccount = `${i.coa_coex_code} ${i.coa_coex_name}`;

    return journalMap(watch('transaction_date'),
      i.product_barcode,
      inventoryAccount,
      coexAccount,
      i.stock_in || 0,
      i.stock_out || 0,
      Number(amount)
    )
  })

  const totalCredit = dataJournal.reduce((prev, curr) => prev + Number(curr.credit), 0);
  const totalDebet = dataJournal.reduce((prev, curr) => prev + Number(curr.debet), 0);

  const dataJournalFill = dataJournal.slice().sort((a, b) => {
    if (a.debet && !b.debet) return -1;
    if (!a.debet && b.debet) return 1;
    return 0;
  })

  return (
    <Fragment>
      <CommandButton actiontype="journal" onClick={toggle} />

      {isActive && (
        <Modal isOpen title="JOURNAL" closeModal={toggle} size="full">
          <Modal.Body>
            <JournalTable>
              <JournalTable.Content>
                <TableHeader>
                  <tr>
                    <th>DATE</th>
                    <th>IDM</th>
                    <th>ACCOUNT</th>
                    <th>DEBET</th>
                    <th>CREDIT</th>
                  </tr>
                </TableHeader>

                <tbody>
                  {dataJournalFill.length > 0 ? dataJournalFill.map((item, index) => {
                    return (
                      (
                        <tr key={index}>
                          <td>{moment(item.date).format("DD/MM/YYYY")}</td>
                          <td>{item.idm}</td>
                          <td>{item.account}</td>
                          <td className="text-right">{item.debet ? convertNumber(Math.abs(item.debet)).intoCurrency : ''}</td>
                          <td className="text-right">{item.credit ? convertNumber(Math.abs(item.credit)).intoCurrency : ''}</td>
                        </tr>
                      )
                    )
                  }) : (<tr><td colSpan={5} className="text-center">No Data</td></tr>)}
                </tbody>
              </JournalTable.Content>
              <JournalTable.Amount>
                <tfoot>
                  <tr className="text-xl font-bold">
                    <th className="text-right">TOTAL</th>
                    <th className="text-right">
                      {totalCredit ? convertNumber(Math.abs(totalCredit)).intoCurrency : "0"}
                    </th>
                    <th className="text-right">
                      {totalDebet ? convertNumber(Math.abs(totalDebet)).intoCurrency : "0"}
                    </th>
                  </tr>
                </tfoot>
              </JournalTable.Amount>
            </JournalTable>
          </Modal.Body>
        </Modal>
      )}
    </Fragment>
  )
}